import { Flow } from '../../interfaces/Flow'
import { FlowAction } from '../actions/flowActions'
import { GET_FLOW_EXITO } from '../types/flowActionsTypes'

export interface FlowState {
  flowsState: {
    flows?: Flow[]
    error?: string
  }
}

const initialState: FlowState = {
  flowsState: { flows: [], error: '' }
}

export const flowsReducer = (
  state: FlowState = initialState,
  action: FlowAction
): FlowState => {
  if (action.type === GET_FLOW_EXITO) {
    return {
      ...state,
      flowsState: {
        flows: action.flows,
        error: action.error
      }
    }
  }
  return state
}
